import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Header from '../components/Header'
import Container from '../components/Container'
import CustomSelect from '../components/CustomSelect'
import { countryList, languageList } from '../constants/index.js'
import { setCountry, setLanguage, setCurrency, setNumberSystem } from '../redux/settings/settingsSlice'
import useLocale from '../locales'

const Settings = () => {
    const dispatch = useDispatch()
    const { textData } = useLocale()
    const { country, language, currency } = useSelector((state) => state.settings)

    const handleCountryChange = (value) => {
        dispatch(setCountry(value))
        const country = countryList.find(country => country.countryCode === value.value)
        if (country) {
            dispatch(setNumberSystem(country.numberSystem))
        }
    }

    const handleLanguageChange = (value) => {
        dispatch(setLanguage(value))
    }

    const handleCurrencyChange = (value) => {
        dispatch(setCurrency(value))
    }
    return (
        <div>
            <Header />
            <div className='mt-5'>
                <Container>
                    <h1 className='text-2xl font-bold'>{textData.settings?.title || 'Settings'}</h1>
                    <div className='flex flex-wrap gap-4 mt-8 '>
                        <div className='flex flex-col gap-2'>
                            <h2 className='text-lg font-bold'>{textData.settings?.country || 'Country'}</h2>
                            <CustomSelect
                                className='!w-[200px]'
                                options={countryList.map(country => ({
                                    value: country.countryCode,
                                    label: `${country.name} (${country.flag})`,
                                }))}
                                value={country}
                                onChange={handleCountryChange}
                            />
                        </div>
                        <div className='flex flex-col gap-2'>
                            <h2 className='text-lg font-bold'>{textData.settings?.currency || 'Currency'}</h2>
                            <CustomSelect
                                className='!w-[200px]'
                                options={Array.from(
                                    languageList
                                        .reduce((acc, item) => {
                                            if (!acc.has(item.currencyCode)) {
                                                acc.set(item.currencyCode, {
                                                    value: item.currencyCode,
                                                    label: `${item.currencyCode}-${item.currencyName} (${item.currency})`,
                                                })
                                            }
                                            return acc
                                        }, new Map())
                                        .values()
                                )}
                                value={currency}
                                onChange={handleCurrencyChange}
                            />
                        </div>
                        <div className='flex flex-col gap-2'>
                            <h2 className='text-lg font-bold'>{textData.settings?.language || 'Language'}</h2>
                            <CustomSelect
                                className='!w-[200px]'
                                options={languageList.map(language => ({
                                    value: language.code,
                                    label: `${language.flag} ${language.name} ${language.language}`,
                                }))}
                                value={language}
                                onChange={handleLanguageChange}
                            />
                        </div>
                    </div>
                </Container>
            </div>
        </div>
    )
}

export default Settings
